<template>
  <component v-for="block, key in activeBlocks"
    :key="block.key"
    :is="resolveBlock(block)"
    :block="block"
    :class="{
      'is-root': block.depth === 0,
      'is-first': key === 0,
      'is-last': key + 1 === activeBlocks.length,
      // 'is-slim': block.depth === 0 && slimBlocks.includes(block.name),
    }"
  />
</template>

<script setup>
const props = defineProps({
  blocks: Array,
  allowedBlocks: {
    type: Array,
    default: () => []
  }
})

const activeBlocks = (props.blocks ?? [])
  .filter(block => block?.active)
  .filter(block => props.allowedBlocks.length
    ? props.allowedBlocks.includes(block.name)
    : true)

const resolveBlock = (block) =>  {
  const { name, data } = block 

  // Core Blocks
  if (name === 'heading') return resolveComponent('BlocksCoreText')
  if (name === 'paragraph') return resolveComponent('BlocksCoreText')
  if (name === 'list') return resolveComponent('BlocksCoreList')
  if (name === 'list_item') return resolveComponent('BlocksCoreListItem')
  // if (name === 'button') return resolveComponent('BlocksCoreButton')
  // if (name === 'buttons') return resolveComponent('BlocksCoreButtons')
  if (name === 'separator') return resolveComponent('BlocksCoreSeparator')
  if (name === 'image') return resolveComponent('BlocksCoreImage')
  // if (name === 'quote') return resolveComponent('BlocksCoreQuote')
  // // ACF Blocks
  if (name === 'intro') return resolveComponent('BlocksIntro')
  if (name === 'author') return resolveComponent('BlocksAuthor')
  if (name === 'hero') return resolveComponent('BlocksHero')
  if (name === 'promo') return resolveComponent('BlocksPromo')
  if (name === 'related' && data?.layout === 'compact') return resolveComponent('BlocksRelatedCompact')
  if (name === 'related') return resolveComponent('BlocksRelated')
  if (name === 'restaurant_reviews') return resolveComponent('BlocksRestaurantReviews')
  if (name === 'restaurant_list' && data?.layout === 'compact') return resolveComponent('BlocksRestaurantListCompact')
  if (name === 'restaurant_list') return resolveComponent('BlocksRestaurantListStandard')
  if (name === 'restaurant_promo') return resolveComponent('BlocksRestaurantPromo')
  if (name === 'restaurant_offers') return resolveComponent('BlocksRestaurantOffers')
  // ACF Native Blocks
  if (name === 'native' && data?.component === 'AppDownloadButtons') return resolveComponent('BlocksNativeAppDownloadButtons')
  if (name === 'native' && data?.component === 'ReservationRequest') return resolveComponent('BlocksNativeReservationRequest')
  if (name === 'native') return resolveComponent('BlocksNative')
  
  // Use debug block
  return resolveComponent('BlocksDebugBlock')
}
</script>

<style lang="scss" scoped>
.is-root {
  &.h1,
  &.h2,
  &.h3,
  &.h4,
  &.h5,
  &.h6,
  &.lead,
  &.base,
  &.meta,
  &.mini,
  &.list,
  &.block-buttons,
  &.block-restaurants,
  &.block-quote,
  &.block-separator {
    // @apply mx-auto max-w-2xl;
  }

  //
  // Standard margins for generic blocks (not text)
  //
  &.block-list,
  &.block-buttons {
    // @apply mt-4;
  }

  //
  // Custom margins for restaurants block
  //
  &.block-restaurants {
    // @apply mt-4 md:mt-6;
  }

  //
  // Large margins for Header, Image, Quote, Separator and Header
  //
  &.block-image,
  &.block-quote,
  &.block-separator {
    // @apply my-6 md:my-10;

    // + *.is-root {
    //   margin-top: 0 !important;
    // }
  }
}
</style>